import { render, staticRenderFns } from "./TemplateModern.vue?vue&type=template&id=61f1a24d&scoped=true&"
import script from "./TemplateModern.vue?vue&type=script&lang=js&"
export * from "./TemplateModern.vue?vue&type=script&lang=js&"
import style0 from "./TemplateModern.vue?vue&type=style&index=0&id=61f1a24d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f1a24d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCol,VIcon,VRow})
